import Image from 'Component/Image';
import {
    MenuItem as SourceMenuItem
} from 'SourceComponent/MenuItem/MenuItem.component';
import { getUrlMedia } from 'Util/Store';

import './MenuItem.override.style';

/** @namespace Elganso/Component/MenuItem/Component */
export class MenuItemComponent extends SourceMenuItem {
    renderExpandButton() {
        const { isExpandable, itemMods } = this.props;

        if (!isExpandable) {
            return null;
        }

        return (
            <figcaption
              block="Menu"
              elem="ExpandedState"
              mods={ itemMods }
            />
        );
    }

    renderItemContent(item, itemMods) {
        const { title, icon } = item;

        if (icon) {
            return (
                <figcaption
                  block="Menu"
                  elem="ItemCaption"
                  mods={ itemMods }
                >
                    <Image src={ `${getUrlMedia()}${icon}` } />
                    { this.renderExpandButton() }
                </figcaption>
            );
        }

        return (
                <figcaption
                  block="Menu"
                  elem="ItemCaption"
                  mods={ itemMods }
                >
                    { title }
                    { this.renderExpandButton() }
                </figcaption>
        );
    }
}

export default MenuItemComponent;
